// ProfileWeb — RunWeb ile yapilan siteler, card layout
import { ExternalLink, Globe } from 'lucide-react'

export interface WebSiteItem {
  id: number | string
  title: string
  url: string
  thumbnail_url?: string
  created_at?: string
}

interface Props {
  items: WebSiteItem[]
  loading?: boolean
}

export default function ProfileWeb({ items, loading }: Props) {
  if (loading) {
    return <div style={{ textAlign: 'center', padding: 40, color: 'var(--text-secondary, #8b949e)', fontSize: 13 }}>Loading...</div>
  }

  if (items.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: 48, color: 'var(--text-secondary, #8b949e)' }}>
        <Globe size={32} style={{ opacity: 0.3, marginBottom: 8 }} />
        <p style={{ fontSize: 14 }}>No web projects yet</p>
      </div>
    )
  }

  return (
    <div style={{
      display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16,
    }}>
      {items.map(site => (
        <div
          key={site.id}
          style={{
            borderRadius: 14, overflow: 'hidden',
            border: '1px solid var(--border-default, #30363d)',
            background: 'rgba(255,255,255,0.02)',
            backdropFilter: 'blur(8px)',
            transition: 'transform 0.25s ease, box-shadow 0.25s ease',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.transform = 'translateY(-4px)'
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(102,126,234,0.15)'
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = 'translateY(0)'
            e.currentTarget.style.boxShadow = 'none'
          }}
        >
          {/* Thumbnail */}
          <div style={{
            height: 160, background: site.thumbnail_url
              ? `url(${site.thumbnail_url}) center/cover`
              : 'linear-gradient(135deg, #1c2128, #30363d)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            {!site.thumbnail_url && <Globe size={36} style={{ color: '#667eea', opacity: 0.4 }} />}
          </div>

          {/* Info */}
          <div style={{ padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ flex: 1 }}>
              <h3 style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary, #e6edf3)', margin: 0 }}>
                {site.title}
              </h3>
              {site.created_at && (
                <p style={{ fontSize: 11, color: 'var(--text-secondary, #8b949e)', margin: '4px 0 0' }}>
                  {new Date(site.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </p>
              )}
            </div>
            <a
              href={site.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit ${site.title}`}
              style={{
                display: 'flex', alignItems: 'center', gap: 5, padding: '7px 12px',
                borderRadius: 8, background: 'linear-gradient(135deg, #667eea, #764ba2)',
                color: '#fff', fontSize: 12, fontWeight: 600, textDecoration: 'none',
                whiteSpace: 'nowrap',
              }}
            >
              <ExternalLink size={12} /> Visit
            </a>
          </div>
        </div>
      ))}
    </div>
  )
}
